import { Radio } from 'antd';
import styled from 'styled-components';
import { NeutralColors } from 'theme';

const RadioGroup = styled(Radio.Group)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 16px;

  .fms-radio-wrapper {
    height: 66px;
    padding: 10px 0;
    align-items: center;
    border-bottom: 1px solid ${NeutralColors[20]};
  }
`;

export { RadioGroup };
